import React, { FC, useEffect, useState } from 'react';
import cn from 'classnames';
import { Link, useLocation } from 'react-router-dom';

import { analytics } from 'src/utils/analytics';
import { useAppSelector } from 'src/hooks/store';
import { selectConfig } from 'src/store/config/selectors';
import Icon from 'src/components/common/Icon';

import css from './ListItem.module.scss';

type Props = {
  id: string;
  title: string;
  imgUrl?: string;
  subtitle?: string;
  tags: string[];
};

export const ListItem: FC<Props> = (props) => {
  const { id, title, imgUrl, subtitle, tags } = props;
  const [indicators, setIndicators] = useState<string[]>([]);
  const location = useLocation();
  const TEXTS = useAppSelector(selectConfig).texts.website.main;

  const storyRoute = `/stories/${id}${location.search}`;

  useEffect(() => {
    const stringsLength = tags.join().length;

    if (stringsLength <= 47) {
      setIndicators(tags);
    } else {
      const [first, second] = tags;
      setIndicators([first, second]);
    }
  }, [tags]);

  const onStoryClick = () => {
    analytics.gtag.event('full story', { CUSTOM_PARAMETER: title });
  };

  return (
    <div className={css.listItem}>
      <div className={css.title}>
        <Link to={storyRoute} title={title} onClick={onStoryClick}>
          <span>{title}</span>
        </Link>
      </div>
      {imgUrl && (
        <div className={css.photo}>
          <Link to={storyRoute} title={title} onClick={onStoryClick}>
            <img src={imgUrl} alt={title} />
          </Link>
        </div>
      )}
      <Link to={storyRoute} title={title} onClick={onStoryClick}>
        <div className={cn(css.subtitle, !imgUrl && css.opened)}>
          <span dangerouslySetInnerHTML={{ __html: subtitle || '' }} />
        </div>
        <div className={css.tags}>
          {indicators.map((tag, index) => {
            return (
              <div className={css.tag} key={`${tag}/${index}`}>
                {tag}
              </div>
            );
          })}
        </div>
      </Link>
      <div className={css.button}>
        <Link to={storyRoute} title={title} onClick={onStoryClick}>
          <span>{TEXTS.list.listItem.button}</span>
          <Icon type="arrow-left" />
        </Link>
      </div>
    </div>
  );
};
